import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon, { ICON_NAME } from '../../../components/Icon';
import { openPopup } from '../../../components/Popup/_components/WrapperPopup';
import PopupFilterVessel from '../../../components/Popup/PopupFilterVessel';
import { selectOneSetting } from '../../../util/store/selectors';
import { AppState } from '../../../util/store/store';
import { OverviewSetting } from '../../../util/varibles/userSetting';
import { loginActions } from '../../LoginPage/reducer';
import styles from '../Calendar/Header/style.module.scss';

const key = OverviewSetting.CREW_VESSEL_FILTER;
const selectVesselFilter = selectOneSetting(key);

const VesselFilter: React.FC = () => {
    const dispatch = useDispatch();
    const vessels = useSelector((state: AppState) => state.overview.wellboats.vessels);
    const overviewVessels = useSelector((state: AppState) => state.overview.vessels);
    const defaultVessel = useSelector((state: AppState) => state.login.user.default_vessel);
    const showAllPlans = useSelector((state: AppState) => state.overview.showAllPlans);
    const selected = useSelector(selectVesselFilter) as string[];

    if (!showAllPlans || vessels.length === 0)
        return null;

    const mainVessel = overviewVessels.find(item => item.id === defaultVessel) || overviewVessels[0];
    const filterVessels = mainVessel && !vessels.some(item => item.id === mainVessel.id)
        ? [mainVessel, ...vessels]
        : vessels;
    const locked = mainVessel ? [mainVessel.id] : [];
    const lockedIds = new Set(locked);
    const selectableVessels = filterVessels.filter(vessel => !lockedIds.has(vessel.id));
    const normalizedSelected = selected.filter(id => !lockedIds.has(id));
    const effectiveSelected = [...locked, ...normalizedSelected];
    const selectedIds = new Set(normalizedSelected);
    const count = selectableVessels.filter(vessel => selectedIds.has(vessel.id)).length;

    const save = (value: string[]) => {
        const filterValue = value.filter(id => !lockedIds.has(id));
        dispatch(loginActions.updateUserSetting([{ [key]: filterValue }]));
    };

    const handleClear = (event: React.MouseEvent) => {
        event.stopPropagation();
        dispatch(loginActions.updateUserSetting([{ [key]: [] }]));
    };

    const handleOpen = () => {
        const popup = openPopup(
            <PopupFilterVessel
                selected={effectiveSelected}
                vessels={filterVessels}
                showCapabilities={false}
                locked={locked}
                onSave={save}
                onClose={() => popup.remove()}
            />
        );
    };

    return <div className={styles.vesselFilter} onClick={handleOpen}>
        <Icon className={styles.icon} icon={ICON_NAME.VESSEL} />
        <span className={styles.name}>Vessel filter</span>
        {count > 0 && <span className={styles.clear} onClick={handleClear}>
            <span>{count}/{selectableVessels.length}</span>
            <Icon icon={ICON_NAME.CLOSE} size="small" />
        </span>}
    </div>;
};

export default VesselFilter;
